module.exports = __webpack_public_path__ + "static/media/sustainability@2x.e07155f5.jpg";